import Page from '../Page';
import kdzy from './kdzy.vue';
import protocol from './protocol.vue';
import copyright from './copyright.vue';
import license from './license.vue';
import { APP_NAME } from '@/constants';

/* eslint-disable no-new */
new Page({
  routes: [
    {
      path: '/',
      component: kdzy,
      meta: { title: `关于${APP_NAME}` }
    },
    {
      name: 'services',
      path: '/services',
      component: protocol,
      meta: { title: '用户服务协议' },
      beforeEnter() {
        window.location.replace('https://gth5.kuaiduizuoye.com/perform/privacy/kd-services');
      },
    },
    {
      name: 'privacy',
      path: '/privacy',
      component: protocol,
      meta: { title: '用户隐私政策' },
      beforeEnter() {
        window.location.replace('https://gth5.kuaiduizuoye.com/perform/privacy/kd-privacy');
      },
    },
    {
      name: 'children',
      path: '/children',
      component: protocol,
      meta: { title: '儿童用户隐私政策' },
      beforeEnter() {
        window.location.replace('https://gth5.kuaiduizuoye.com/perform/privacy/kd-children');
      },
    },
    {
      name: 'copyright',
      path: '/copyright',
      component: copyright,
      meta: { title: '版权投诉' }
    },
    {
      name: 'license',
      path: '/license',
      component: license,
      meta: { title: '资质证照公示' }
    }
  ]
});
